export default "__VITE_ASSET__DtKSKnEg__"